import React from 'react';
import NoneNat from './NoneNat'
import Nat from './Nat'

const Body=({classes, record, samples})=>{
   // console.log(samples)
   // var cu_numbers = samples? samples.map(sample => (sample.cu_numbers).split(',')) : []
   
    return (
        <table className={classes.outerTable} >
            <tbody  >
                <tr>
                    <td>
                        {//samples && samples[0].test_mode !=='NAT' && <NoneNat  classes={classes} samples={samples} cu_numbers={cu_numbers} />
                        }      
                        {//samples && samples[0].test_mode ==='NAT' && <Nat classes={classes} record={record} samples={samples} cu_numbers={cu_numbers}/>
                        }  
                        {samples && samples[0].test_mode !=='NAT' && <NoneNat  classes={classes} samples={samples}  />}      
                        {samples && samples[0].test_mode ==='NAT' && <Nat classes={classes} record={record} samples={samples}/> }   
                    </td>
                </tr>
                
                <tr>
                    <td className={classes.subdiscloser}>
                        {
                        (samples && samples[0].test_mode ==='VMT') ? 'Request testing for HbsAg, Anti-HIV1/2 and Anti-HCV.': (samples && samples[0].test_mode ==='NAT') ? 'Request testing by NAT for: HAV, HBV, HCV, HIV and Parvo  B19'  : ''
                        }
                    </td>
                </tr>
                <tr>
                    <td className={classes.discloser}>
                        By exporting data from this application you assume resposibility for privacy & security of the data in its exported format.<br/>
                        THIS DOCUMENT CONTAINS PROPRIETARY INFORMATION. IT MUST NOT BE REPRODUCED OR DISCLOSED<br/>
                        TO OTHERS WITHOUT PRIOR WRITTEN APPROVAL.
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

export default Body